module.exports = __webpack_public_path__ + "static/salt4-055fc301f61094007fe4fade60a527b7.png";